module.exports = __webpack_public_path__ + "img/SU_Logo.6662cd78.png";